// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import url("https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap"); */
/* * {
  font-family: "Roboto", sans-serif;
  font-size: 12px;
} */
.ticket p {
  margin: 0;
}
.postable td,
.postable th,
.postable tr,
.postable {
  font-size: 18px;
  width: 100%;
  text-align: right;
}
.postable {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  border-collapse: collapse;
  color: black;
  font-weight: 500;
}
.postable th {
  border-bottom: 1px solid black;
  padding: 5px 0;
}
.postable td {
  padding: 0 0 5px 0;
}
.postable tbody tr:first-child td {
  padding-top: 5px;
}
.postable td.sr,
.postable th.sr {
  text-align: left;
  width: 7%;
  max-width: 7%;
}

.postable td.pro,
.postable th.pro {
  text-align: left;
  width: 50%;
  max-width: 50%;
}

.postable td.topping-font{
  font-size: 15px;
}

.postable td.quantity,
.postable th.quantity {
  width: 10%;
  max-width: 10%;
  word-break: break-all;
}

.postable td.price,
.postable th.price {
  width: 15%;
  max-width: 15%;
  word-break: break-all;
}

.postable td.amount,
th.amount {
  width: 25%;
  max-width: 25%;
  word-break: break-all;
}
.postable td.subtotal {
  text-align: right;
}

.postable td.discount {
  text-align: right;
}

.postable td.subtotalamount {
  font-size: 20px;
  font-weight: 600;
  text-align: right;
}
.postable td.grand {
  padding: 5px 0;
  border-top: 1px solid black;
  font-weight: 500;
  font-size: 20px;
  text-align: right;
}

.postable td.grandtotal {
  padding: 5px 0;
  border-top: 1px solid black;
  font-size: 20px;
  font-weight: 600;
  text-align: right;
}

.postable td.priceword {
  padding: 5px 0;
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  font-weight: 500;
  text-align: left;
  font-style: italic;
}

.postable.top-table {
  border-top: 1px solid transparent;
}

.centered {
  padding: 0;
  padding: 5px 0;
  margin: 0;
  text-align: center;
  align-content: center;
}
.centered p {
  font-size: 20px;
  margin: 5px;
  text-transform: capitalize;
  font-weight: 700;
}
.centered p.gstNumber {
  font-size: 17px;
  margin: 5px;
  text-transform: capitalize;
  font-weight: 300;
}
.ticket {
  /* font-family: "Roboto", sans-serif; */
  font-family: "Open Sans", sans-serif;
  font-size: 20px;
  /* padding: 5px; */
  width: 100mm;
  max-width: 100mm;
  color: black;
}

.info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  padding: 5px 0 10px 0;
  color: black;
}

.info .subinfo {
  text-transform: capitalize;
  padding: 2px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.info .subinfo p {
  font-size: 18px;
}

.mobile {
  padding: 0 0 5px 0;
}

.logo {
  width: 150px;
}
.gstNumber {
  font-weight: 400;
}
@media print {
  .hidden-print,
  .hidden-print * {
    display: none !important;
  }
}
@media only screen and (max-device-width: 480px) {
  .logo {
    width: 80px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/KOTcomponent/invoice.css"],"names":[],"mappings":"AAAA,kGAAkG;AAElG;;;GAGG;AACH;EACE,SAAS;AACX;AACA;;;;EAIE,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,8BAA8B;EAC9B,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;EAChB,SAAS;EACT,aAAa;AACf;;AAEA;;EAEE,gBAAgB;EAChB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,UAAU;EACV,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,UAAU;EACV,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,UAAU;EACV,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,WAAW;EACX,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,WAAW;EACX,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,uCAAuC;EACvC,oCAAoC;EACpC,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE;;IAEE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":["/* @import url(\"https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap\"); */\n@import url(\"https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700&display=swap\");\n/* * {\n  font-family: \"Roboto\", sans-serif;\n  font-size: 12px;\n} */\n.ticket p {\n  margin: 0;\n}\n.postable td,\n.postable th,\n.postable tr,\n.postable {\n  font-size: 18px;\n  width: 100%;\n  text-align: right;\n}\n.postable {\n  border-top: 1px solid black;\n  border-bottom: 1px solid black;\n  border-collapse: collapse;\n  color: black;\n  font-weight: 500;\n}\n.postable th {\n  border-bottom: 1px solid black;\n  padding: 5px 0;\n}\n.postable td {\n  padding: 0 0 5px 0;\n}\n.postable tbody tr:first-child td {\n  padding-top: 5px;\n}\n.postable td.sr,\n.postable th.sr {\n  text-align: left;\n  width: 7%;\n  max-width: 7%;\n}\n\n.postable td.pro,\n.postable th.pro {\n  text-align: left;\n  width: 50%;\n  max-width: 50%;\n}\n\n.postable td.topping-font{\n  font-size: 15px;\n}\n\n.postable td.quantity,\n.postable th.quantity {\n  width: 10%;\n  max-width: 10%;\n  word-break: break-all;\n}\n\n.postable td.price,\n.postable th.price {\n  width: 15%;\n  max-width: 15%;\n  word-break: break-all;\n}\n\n.postable td.amount,\nth.amount {\n  width: 25%;\n  max-width: 25%;\n  word-break: break-all;\n}\n.postable td.subtotal {\n  text-align: right;\n}\n\n.postable td.discount {\n  text-align: right;\n}\n\n.postable td.subtotalamount {\n  font-size: 20px;\n  font-weight: 600;\n  text-align: right;\n}\n.postable td.grand {\n  padding: 5px 0;\n  border-top: 1px solid black;\n  font-weight: 500;\n  font-size: 20px;\n  text-align: right;\n}\n\n.postable td.grandtotal {\n  padding: 5px 0;\n  border-top: 1px solid black;\n  font-size: 20px;\n  font-weight: 600;\n  text-align: right;\n}\n\n.postable td.priceword {\n  padding: 5px 0;\n  border-top: 1px solid black;\n  border-bottom: 1px solid black;\n  font-weight: 500;\n  text-align: left;\n  font-style: italic;\n}\n\n.postable.top-table {\n  border-top: 1px solid transparent;\n}\n\n.centered {\n  padding: 0;\n  padding: 5px 0;\n  margin: 0;\n  text-align: center;\n  align-content: center;\n}\n.centered p {\n  font-size: 20px;\n  margin: 5px;\n  text-transform: capitalize;\n  font-weight: 700;\n}\n.centered p.gstNumber {\n  font-size: 17px;\n  margin: 5px;\n  text-transform: capitalize;\n  font-weight: 300;\n}\n.ticket {\n  /* font-family: \"Roboto\", sans-serif; */\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 20px;\n  /* padding: 5px; */\n  width: 100mm;\n  max-width: 100mm;\n  color: black;\n}\n\n.info {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-direction: column;\n  padding: 5px 0 10px 0;\n  color: black;\n}\n\n.info .subinfo {\n  text-transform: capitalize;\n  padding: 2px;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.info .subinfo p {\n  font-size: 18px;\n}\n\n.mobile {\n  padding: 0 0 5px 0;\n}\n\n.logo {\n  width: 150px;\n}\n.gstNumber {\n  font-weight: 400;\n}\n@media print {\n  .hidden-print,\n  .hidden-print * {\n    display: none !important;\n  }\n}\n@media only screen and (max-device-width: 480px) {\n  .logo {\n    width: 80px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
